/** True when `pathname` is `base` or below it (never a sibling that merely shares a prefix). */
export const pathIsUnder = (pathname: string, base: string) =>
  pathname === base || pathname.startsWith(`${base}/`);

export const isNavRouteActive = (
  pathname: string,
  collapseName: string,
  route?: string,
  key?: string,
  activePaths: string[] = []
) => {
  if (route && pathIsUnder(pathname, route)) {
    return true;
  }
  if (activePaths.some((base) => pathIsUnder(pathname, base))) {
    return true;
  }
  return Boolean(key) && key === collapseName;
};
